export default __webpack_public_path__ + "static/media/snow_dayTime.f2440abe.svg";